export const PERIOD_CONSTANT = {
    MORNING: {
        START:"00:00",
        END:"10:59"
    },
    AFTERNOON: {
        START:"11:00",
        END:"15:59"
    },
    EVENING: {
        START:"16:00",
        END:"23:59"
    },
    ALL_DAY:{
        START:"00:00",
        END:"23:59"
    }
}

export const LIST_PERIOD_CONSTANT = [ PERIOD_CONSTANT.MORNING, PERIOD_CONSTANT.AFTERNOON, PERIOD_CONSTANT.EVENING ];